module.exports = __webpack_public_path__ + "static/media/about_us.498d4c84.webp";